import { useContext } from 'react';
import CardThree from '../Cards/CardThree/CardThree';
import './Lawyer.scss';
import { CurrentLangContext, LangContext } from '../../contexts/contexts';

function Lawyer() {
  const langs = useContext(LangContext);
  const lawyersLangs = langs.lawyer;

  const CurrentLangC = useContext(CurrentLangContext);
  const currentLang = CurrentLangC[0];

  return (
    <section id="lawyer" className="Lawyer">
      <h1 className="Lawyer_title">{lawyersLangs.title[currentLang]}</h1>
      <div className="Lawyer_container">
        <div className="lawyer_content">
          <div className="lawyer_immo">
            <CardThree />
            <CardThree />
            <CardThree />
            <CardThree />
            <CardThree />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Lawyer;